'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _redux = require('redux');

var _reactRedux = require('react-redux');

var _reactReduxForm = require('react-redux-form');

var _reduxThunk = require('redux-thunk');

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _simpleGrayLayout = require('common/components/simple-gray-layout');

var _simpleGrayLayout2 = _interopRequireDefault(_simpleGrayLayout);

var _recoverPasswordForm = require('./recover-password-form');

var _recoverPasswordForm2 = _interopRequireDefault(_recoverPasswordForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Top-level component for standalone Recover Password (Forgot Password) page.
 * Expects some props from the backend, such as CSRF token.
 */
var RecoverPasswordPage = function (_React$Component) {
    _inherits(RecoverPasswordPage, _React$Component);

    function RecoverPasswordPage(props) {
        _classCallCheck(this, RecoverPasswordPage);

        // Prepare initial form state
        var _this = _possibleConstructorReturn(this, (RecoverPasswordPage.__proto__ || Object.getPrototypeOf(RecoverPasswordPage)).call(this, props));

        var initialState = {
            email: _this.props.email || window.sessionStorage['email'],
            csrfToken: _this.props.csrfToken
        };
        window.sessionStorage.removeItem('email');

        // Set up Redux store
        _this.store = (0, _redux.createStore)((0, _reactReduxForm.combineForms)({
            recoverPassword: initialState
        }), (0, _redux.applyMiddleware)(_reduxThunk2['default']));
        return _this;
    }

    _createClass(RecoverPasswordPage, [{
        key: 'render',
        value: function render() {
            return _react2['default'].createElement(
                _reactRedux.Provider,
                { store: this.store },
                _react2['default'].createElement(
                    _simpleGrayLayout2['default'],
                    null,
                    _react2['default'].createElement(_recoverPasswordForm2['default'], null)
                )
            );
        }
    }]);

    return RecoverPasswordPage;
}(_react2['default'].Component);

RecoverPasswordPage.propTypes = {
    // CSRF Token - Sent from the server
    csrfToken: _react2['default'].PropTypes.string.isRequired,

    // Email value - This is useful to provide for testing purposes
    email: _react2['default'].PropTypes.string
};


module.exports = RecoverPasswordPage;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/auth/recover-password-page.jsx
 ** module id = 1012
 ** module chunks = 0
 **/